module.exports = __webpack_public_path__ + "img/phoneBg.615f884a.png";